import type { AxiosPromise } from "axios";
import { apiClient } from "@/api/modules/base";
import type {
    ContaminantsListItem,
    ContaminantsListRequest
} from "@/api/modules/autoQ/contaminants/types";
import { Route } from "@/api/modules/autoQ/contaminants/route";


export const list = (payload: ContaminantsListRequest): AxiosPromise<ContaminantsListItem[]> =>
    apiClient.get(Route.Contaminants, { params: { productId: payload.productId } });
